module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular07-07e49762c45a08a9d9c3a504cc0f99ac.png";